import * as React from 'react';
import Button from '../../Components/Button';
import Checkbox from '../../Components/Checkbox';
import Divider from '../../Components/Divider';
import Header from '../../Components/Header';
import StringFormatter from '../../Helpers/StringFormatter';
import Product from '../../Models/Product';
import { IDebitCardDetails } from '../../Types/Payments/IDebitCardDetails';
import DonationArea from '../Types/DonationArea';
import Member from '../Types/Member';
import { PaymentDetails } from './Payment';
import { PaymentFrequency } from './PaymentForms/DirectDebitPaymentForm';
import ReactHtmlParser from 'html-react-parser';

require('../../css/membership-signup-summary.css');

export interface Props {
  termsAndConditionsText?: string;
  member: Member;
  paymentDetails: PaymentDetails;
  product: Product;

  giftAidEnabled: boolean;
  giftAidOptions: GiftAidOptions;

  buttonClass?: string;
  submitAreaBackgroundColor?: string;
  headingColor?: string;
  priceSymbol?: string;
  useLoqateValidation?: boolean;

  ddType?: string;
  creditorName?: string;
  creditorID?: string;
  creditorAddress?: string;
  transactionType?: string;
  ibanNumber?: string;
  accountNumber?: string;
  sortCode?: string;

  goTo(area: DonationArea): void;
  next(): void;
}

interface State {
  consented: boolean;
}

class MembershipSummary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      consented: false
    };
  }

  renderCostSummary = () => {
    return (
      <>
        <b>{this.props.product.name}</b> - {this.props.priceSymbol}

        {StringFormatter.numberAsCurrency(this.props.product.priceInPence)}

        <br />

        <span>{this.props.product.description}</span>

        <br />
      </>
    );
  };

  renderGiftAidSummary = () => {
    const ga = this.props.giftAidOptions;

    if (ga.isSelected === false) {
      return (
        <>
          <b>You have chosen not to GiftAid your contributions.</b>
          <br />
          <span>
            With GiftAid we could receive {this.renderGiftAidTotal(this.props.product.priceInPence)} at no
            extra cost to you.
          </span>
        </>
      );
    } else {
      return (
        <>
          Thank you for choosing GiftAid! We will receive{' '}
          {this.renderGiftAidTotal(this.props.product.priceInPence)}.<br />
          <b>
            You have chosen to GiftAid your contributions using this UK address:
          </b>
          <br />
          <br />
          {StringFormatter.ExcludeNullEmpty(ga.addressLine1)}
          {StringFormatter.ExcludeNullEmpty(ga.addressLine2)}
          {StringFormatter.ExcludeNullEmpty(ga.addressLine3)}
          {StringFormatter.ExcludeNullEmpty(ga.town)}
          {StringFormatter.ExcludeNullEmpty(ga.county)}
          {StringFormatter.ExcludeNullEmpty(ga.postcode)}
          {StringFormatter.ExcludeNullEmpty(ga.country)}
          <br />
        </>
      );
    }
  };

  renderPersonalDetails = () => {
    const info = this.props.member.personalInfo;
    const address = this.props.member.address;

    return (
      <>
        {StringFormatter.FormatPersonName(
          info.title,
          info.firstName,
          info.lastName
        )}
        <br />
        <br />
        {StringFormatter.FormatAddress(address)}
        <br />
        {info.email}
        <br />
      </>
    );
  };

  renderSummaryDetails = () => {
    let submitClass = 'light-wrapper addressLocatorBackground';
    var today = new Date();
    var newdate = StringFormatter.GetFullMonth(today.getMonth()) + ' ' + today.getDate() + ',' + today.getFullYear();
    var date = today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear();

    return (
      <>
        <div >
          <div>
              SEPA Direct Debit mandate
              <br />
              Date of mandate: {newdate}
              <br />
              Transaction type: {this.props.transactionType}
              <br />
              <br />
              Creditor information
              <br />
              Creditor name: {this.props.creditorName}
              <br />
              Creditor ID: {this.props.creditorID}
              <br />
              Creditor address: {this.props.creditorAddress}
              <br />
              { this.props.ibanNumber &&
              <>
              <span>Payer IBAN: {this.props.ibanNumber}</span> 
              </>
              }
              { this.props.accountNumber &&
              <>
              <span>Payer Account number: {this.props.accountNumber}</span> 
              </>
              }
               { this.props.sortCode &&
              <>
              <br/>
              <span>Payer Sort code: {this.props.sortCode}</span> 
              </>
              }
              <br />
              <br />
              “We will notify you at least 3 working days in advance of any changes to your payment date, frequency, or amount”
              <br />
              <br />
              By signing this mandate form, you authorise <br /> (A) {this.props.creditorName} to send instructions to your bank to debit your
              account and<br /> (B) your bank to debit your account in accordance with the instruction from {this.props.creditorName}.
              As part of your rights, you are entitled to a refund from your bank under the terms and conditions of your agreement with your bank.
              A refund must be claimed within 8 weeks starting from the date on which your account was debited.
              Your rights are explained in a statement that you can obtain from your bank.
          </div>
          <br />
        </div>
      </>
    );
  };

  renderDefaultSummaryDetails = () => {
    let submitClass = 'light-wrapper addressLocatorBackground';
    var today = new Date();
    var newdate = StringFormatter.GetFullMonth(today.getMonth()) + ' ' + today.getDate() + ',' + today.getFullYear();
    var date = today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear();

    return (
      <>
        <div >
          <div>
              BACS Direct Debit mandate
              <br />
              Date of mandate: {newdate}
              <br />
              Transaction type: {this.props.transactionType}
              <br />
              <br />
              Creditor information
              <br />
              Creditor name: {this.props.creditorName}
              <br />
              Creditor ID: {this.props.creditorID}
              <br />
              Creditor address: {this.props.creditorAddress}
              <br />
              { this.props.ibanNumber &&
              <>
              <span>Payer IBAN: {this.props.ibanNumber}</span> 
              </>
              }
              { this.props.accountNumber &&
              <>
              <span>Payer Account number: {this.props.accountNumber}</span> 
              </>
              }
               { this.props.sortCode &&
              <>
              <br/>
              <span>Payer Sort code: {this.props.sortCode}</span> 
              </>
              }
              <br />
              <br />
              “We will notify you at least 3 working days in advance of any changes to your payment date, frequency, or amount”
              <br />
              <br />
              By signing this mandate form, you authorise <br /> (A) {this.props.creditorName} to send instructions to your bank to debit your
              account and<br /> (B) your bank to debit your account in accordance with the instruction from {this.props.creditorName}.
              As part of your rights, you are entitled to a refund from your bank under the terms and conditions of your agreement with your bank.
              A refund must be claimed within 8 weeks starting from the date on which your account was debited.
              Your rights are explained in a statement that you can obtain from your bank.
          </div>
          <br />
        </div>
      </>
    );
  };

  renderSections = () => {
    const props = this.props;

    let sections: JSX.Element[] = [];

    let headingColorClass = '';
    if (this.props.headingColor) {
      headingColorClass = this.props.headingColor;
    }

    // sections.push(this.renderCostSummary());

    sections.push(
      <Header headingClassName={headingColorClass} onEditClick={() => props.goTo(DonationArea.MemberDetails)}>
        Payer
      </Header>
    );

    sections.push(this.renderPersonalDetails());

    if (this.props.ddType === 'SEPA' && this.props.paymentDetails.kind !== 'creditcard') {
    sections.push(<Divider />);
    sections.push(
      <Header headingClassName={headingColorClass} onEditClick={() => props.goTo(DonationArea.Payment)}>
          Direct Debit detail
      </Header>
    );
    sections.push(this.renderSummaryDetails());
    }

    if (this.props.ddType !== 'SEPA' && this.props.paymentDetails.kind !== 'creditcard') {
    sections.push(<Divider />);
    sections.push(
      <Header headingClassName={headingColorClass} onEditClick={() => props.goTo(DonationArea.Payment)}>
          Direct Debit detail
      </Header>
    );
    sections.push(this.renderDefaultSummaryDetails());
      
    }

    if (props.giftAidEnabled) {
      sections.push(<Divider />);
      sections.push(
        <Header headingClassName={headingColorClass} onEditClick={() => props.goTo(DonationArea.GiftAid)}>
          GiftAid
        </Header>
      );
      sections.push(this.renderGiftAidSummary());
    }

    sections.push(<Divider />);
    sections.push(<Header headingClassName={headingColorClass}>Payment</Header>);
    sections.push(this.renderPaymentSource());
    if (this.props.useLoqateValidation && this.props.paymentDetails.kind === 'directdebit') {
      sections.push(this.bankInformation());
    }
    return sections;
  };

  bankInformation() {
    let details = this.props.paymentDetails as IDebitCardDetails;
    return (
      <>
      <span>
       Bank Name : {details.bankName} 
      </span>
      <br/>
      <span>
      Branch Name : {details.branchName} 
     </span>
     <br/>
     </>
    );
  } 
  
  renderGiftAidTotal = (preGiftAidTotal: number) => {
    let amountAfterGiftAid = Math.round(preGiftAidTotal * 1.25);

    return (
      <span className="giftaid-value">
        {this.props.priceSymbol}{StringFormatter.numberAsCurrency(amountAfterGiftAid)}
      </span>
    );
  };

  renderPaymentSource = () => {
    switch (this.props.paymentDetails.kind) {
      case 'directdebit':
        return (
          <span>
            Direct Debit
            <br />
            {/* <small>
              <b>
                (Physical benefits will not be available until first payment has
                been received. Digital benefits will be available immediately.)
              </b>
            </small> */}
            <br />
          </span>
        );
      case 'creditcard':
        return <></>;
      case 'bankaccount':
        return <></>;
      default:
        // const _compileErrorIfUnhandledCase: never = this.props.paymentDetails;
        throw new Error('payment method unhandled');
    }
  };

  frequencyDivider = () => {
    switch (this.props.paymentDetails.paymentFrequency) {
      case PaymentFrequency.Annually:
        return 1;
      case PaymentFrequency.Biannually:
        return 2;
      case PaymentFrequency.Quarterly:
        return 4;
      case PaymentFrequency.Monthly:
        return 12;
      default:
        throw 'Frequency does not have a dividing amount';
    }
  };

  render() {
    let submitClass = 'light-wrapper ';

    if (this.props.submitAreaBackgroundColor) {
      submitClass += this.props.submitAreaBackgroundColor;
    }

    return (
      <div id="membership-signup-summary">

        {this.renderSections()}

        <br />

        {this.renderPaymentSummary(this.props.product.priceInPence)}

        <div className={submitClass}>
          <div>
            <Checkbox
              checked={this.state.consented}
              id="rhythm-mem-signup-consent"
              label={this.props.termsAndConditionsText === undefined ? '' : this.props.termsAndConditionsText}
              onChange={b =>
                this.setState(state => ({ ...state, consented: b }))
              }
            />
          </div>

          <br />

          <div className="marginTop20 sidePane">
            <Button className={this.props.buttonClass} onClick={this.props.next} disabled={!this.state.consented}>
              Pay Now
            </Button>
          </div>
        </div>
      </div>
    );
  }

  renderPaymentSummary(total: number) {
    let startDay = '';
    if (this.props.paymentDetails.kind === 'bankaccount' || this.props.paymentDetails.kind === 'creditcard') {
      startDay = this.props.paymentDetails.dateToDonateInMonth;
    } else if ( this.props.paymentDetails.kind === 'directdebit') {
      startDay = this.props.paymentDetails.paymentDay;
    }
    let dayInMonth = '';
    switch (startDay) {
      case '1':
        dayInMonth = '1st';
        break;
      case '15':
        dayInMonth = '15th';
        break;
      case '0':
        dayInMonth = 'last day';
        break;
      default:
        dayInMonth = '';
        break;
    }

    if (this.props.product.paymentSelection === 'monthly') {
      return (
        <div style={{ textAlign: 'left' }}>
          <span className="total-price">
            Amount: <b>{this.props.priceSymbol}{StringFormatter.numberAsCurrency(total)}</b> per
              month
            </span>
          <br />
          {/*   Paying {
            PaymentFrequency[this.props.paymentDetails.paymentFrequency]
          }{' '}
            in installments of:&nbsp; {this.props.priceSymbol}
          {StringFormatter.numberAsCurrency(
            Math.ceil(total / this.frequencyDivider())
          )} */}
          The donation will be charged on {dayInMonth} of every month starting from{' '}
        {StringFormatter.GetFullMonth(Number(this.props.paymentDetails.startDonationFrom.month) - 1)}, {'20'}{this.props.paymentDetails.startDonationFrom.year}
        </div>
      );
    }
    
    return (
      <div style={{ textAlign: 'left' }}>
        <span className="total-price">
          Amount: <b>{this.props.priceSymbol}{StringFormatter.numberAsCurrency(total)}</b>
        </span>
      </div>
    );
    
  }
}

export default MembershipSummary;


// WEBPACK FOOTER //
// ./src/MakeDonation/SignupJourney/Summary.tsx